(function (window, document) {
  'use strict';
  if (window.__gbgear) return;
  window.__gbgear = 2;
  var cart = null, desired = {}, versions = {}, running = {}, pointerGesture = null, legacyTouch = null, rowStates = new WeakMap(), booted = false;
  var flushTimer = null, flushing = false;
  // Fast taps ride in one cart write (2026-11-01, Emi: "site becomes laggy when I click a-lot"): every Shopify cart write
  // takes about 0.5-0.9 s, and one write per tap, queued one after another, kept the buttons busy for seconds after a
  // burst. The first write waits BATCH_MS for more taps; taps made while a write is on its way go in the next one.
  var BATCH_MS = 150;
  // A finger wobbles a few px on a normal tap (phones allow ~10 px before they call it a scroll); 4 px made real taps
  // count as drags and get dropped (2026-11-01, Emi: "swiping is still buggy"). A mouse keeps the strict 4 px.
  var MOVE_THRESHOLD = 4, TOUCH_MOVE_THRESHOLD = 10, DRAG_CLICK_GUARD_MS = 650, SCROLL_CLICK_GUARD_MS = 500;
  function cardForEvent(event) {
    return event.target && event.target.closest && event.target.closest('[data-gbgear] [data-gbit]');
  }
  function rowForCard(card) {
    return card && card.closest && card.closest('[data-gbgear] [data-gbrow]');
  }
  function stateForRow(row) {
    var state = rowStates.get(row);
    if (!state) { state = { lastScrollAt: null, suppressUntil: 0 }; rowStates.set(row, state); }
    return state;
  }
  function markMoved(gesture) {
    if (!gesture || gesture.moved) return;
    gesture.moved = true;
    gesture.dragging = true;
    gesture.row.classList.add('is-dragging');
    stateForRow(gesture.row).suppressUntil = performance.now() + DRAG_CLICK_GUARD_MS;
  }
  function updateMovement(gesture, x, y) {
    if (!gesture || gesture.moved || typeof x !== 'number' || typeof y !== 'number') return;
    var limit = gesture.pointerType === 'mouse' || gesture.pointerType === 'pen' ? MOVE_THRESHOLD : TOUCH_MOVE_THRESHOLD;
    if (Math.hypot(x - gesture.x, y - gesture.y) >= limit) markMoved(gesture);
  }
  // A scroll while a finger or mouse is down but has not moved is the browser bringing a tapped, half-hidden card into
  // view, not a swipe; it must not swallow that tap.
  function heldStill(row) {
    var gesture = pointerGesture || legacyTouch;
    return !!(gesture && gesture.row === row && !gesture.moved);
  }
  function suppressed(row) {
    var state = row && rowStates.get(row), now = performance.now();
    return !!(state && (now < state.suppressUntil || (state.lastScrollAt !== null && now - state.lastScrollAt < SCROLL_CLICK_GUARD_MS)));
  }
  function finishGesture(gesture) {
    if (!gesture) return;
    if (gesture.moved) stateForRow(gesture.row).suppressUntil = performance.now() + DRAG_CLICK_GUARD_MS;
    if (gesture.dragging) gesture.row.classList.remove('is-dragging');
  }
  function onPointerDown(event) {
    if (event.isPrimary === false) return;
    var card = cardForEvent(event), row = rowForCard(card);
    if (!row) return;
    if (pointerGesture && pointerGesture.dragging) pointerGesture.row.classList.remove('is-dragging');
    pointerGesture = { pointerId: event.pointerId, pointerType: event.pointerType, card: card, row: row, x: event.clientX, y: event.clientY, moved: false, dragging: false };
  }
  function onPointerMove(event) {
    if (!pointerGesture || event.pointerId !== pointerGesture.pointerId) return;
    updateMovement(pointerGesture, event.clientX, event.clientY);
  }
  function onPointerEnd(event) {
    if (!pointerGesture || event.pointerId !== pointerGesture.pointerId) return;
    updateMovement(pointerGesture, event.clientX, event.clientY);
    finishGesture(pointerGesture);
    pointerGesture = null;
  }
  function onPointerCancel(event) {
    if (!pointerGesture || event.pointerId !== pointerGesture.pointerId) return;
    updateMovement(pointerGesture, event.clientX, event.clientY);
    if (pointerGesture.pointerType === 'touch') {
      if (pointerGesture.moved) stateForRow(pointerGesture.row).suppressUntil = performance.now() + DRAG_CLICK_GUARD_MS;
      return; // Native scrolling cancels pointer events before the finger lifts.
    }
    finishGesture(pointerGesture);
    pointerGesture = null;
  }
  function onNativeTouchEnd(event) {
    if (!pointerGesture || pointerGesture.pointerType !== 'touch' || (event.touches && event.touches.length)) return;
    finishGesture(pointerGesture);
    pointerGesture = null;
  }
  window.addEventListener('pointerdown', onPointerDown, { passive: true, capture: true });
  window.addEventListener('pointermove', onPointerMove, { passive: true, capture: true });
  window.addEventListener('pointerup', onPointerEnd, { passive: true, capture: true });
  window.addEventListener('pointercancel', onPointerCancel, { passive: true, capture: true });
  document.addEventListener('touchend', onNativeTouchEnd, { passive: true, capture: true });
  document.addEventListener('touchcancel', onNativeTouchEnd, { passive: true, capture: true });
  if (!window.PointerEvent) {
    document.addEventListener('touchstart', function (event) {
      var card = cardForEvent(event), row = rowForCard(card), point = event.touches && event.touches[0];
      legacyTouch = row && point ? { card: card, row: row, x: point.clientX, y: point.clientY, moved: false, dragging: false } : null;
    }, { passive: true, capture: true });
    document.addEventListener('touchmove', function (event) {
      var point = event.touches && event.touches[0];
      if (legacyTouch && point) updateMovement(legacyTouch, point.clientX, point.clientY);
    }, { passive: true, capture: true });
    function endLegacyTouch(event) {
      var point = event.changedTouches && event.changedTouches[0];
      if (!legacyTouch) return;
      if (point) updateMovement(legacyTouch, point.clientX, point.clientY);
      finishGesture(legacyTouch);
      legacyTouch = null;
    }
    document.addEventListener('touchend', endLegacyTouch, { passive: true, capture: true });
    document.addEventListener('touchcancel', endLegacyTouch, { passive: true, capture: true });
  }
  window.addEventListener('click', function (event) {
    if (!event.detail) return; // Keep Enter/Space and accessible .click() actions.
    var row = rowForCard(cardForEvent(event));
    if (!row) return;
    if (suppressed(row)) event.stopImmediatePropagation();
  }, { passive: true, capture: true });
  // assets/gb-gear-packs.js may register its own window click listener before this file runs; it asks here first.
  // busy(): taps still on their way to the cart (assets/gb-gear-packs.js keeps its switch banner still until they land).
  window.GBGear = {
    suppressed: function (card) { return !!card && suppressed(rowForCard(card)); },
    busy: function () { return flushing || !!flushTimer || Object.keys(desired).length > 0; }
  };
  function cards() { return document.querySelectorAll('[data-gbgear] [data-gbit]'); }
  function linesFor(id) {
    return ((cart && cart.items) || []).filter(function (line) {
      return String(line.variant_id) === id && line.quantity > 0 && !Object.keys(line.properties || {}).length;
    });
  }
  function setAttr(el, name, value) { if (el.getAttribute(name) !== value) el.setAttribute(name, value); }
  // The card shows the tapped state at once (no "…" while the cart write runs). Attributes are only written when they
  // change: every write restyles the card.
  function paint() {
    cards().forEach(function (card) {
      var id = String(card.dataset.id), wanted = Object.prototype.hasOwnProperty.call(desired, id) ? desired[id] : linesFor(id).length > 0;
      if (card.classList.contains('on') !== wanted) card.classList.toggle('on', wanted);
      setAttr(card, 'role', 'button');
      if (card.tabIndex !== 0) card.tabIndex = 0;
      setAttr(card, 'aria-pressed', String(wanted));
      setAttr(card, 'aria-busy', String(!!running[id]));
      var mark = card.querySelector('.gk');
      if (mark && mark.textContent !== '✓') mark.textContent = '✓';
      // Accessible name = the card's visible text (label-in-name); only the in-flight state appends a hint.
      if (running[id]) {
        if (!card.__gbBusyLabel) {
          card.__gbBusyLabel = true;
          card.setAttribute('aria-label', (card.innerText || card.textContent || '').replace(/\s+/g, ' ').trim() + ' — Updating cart');
        }
      } else if (card.__gbBusyLabel || card.hasAttribute('aria-label')) {
        card.__gbBusyLabel = false;
        card.removeAttribute('aria-label');
      }
    });
  }
  function showError(id, message) {
    cards().forEach(function (card) {
      if (String(card.dataset.id) !== id) return;
      var widget = card.closest('[data-gbgear]');
      var error = widget.querySelector('[data-gbgear-error]');
      if (!error && message) {
        error = document.createElement('p'); error.setAttribute('data-gbgear-error', '');
        error.setAttribute('role', 'alert'); widget.appendChild(error);
      }
      if (error) { error.textContent = message || ''; error.hidden = !message; }
    });
  }
  // A store answer that never comes must not hold the row (and the cart lane behind it): after 15 s it counts as failed.
  function writeCart(url, body, withSections) {
    if (withSections) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 15000) : null;
    return window.fetch(url, {
      method: 'POST', credentials: 'same-origin', signal: ctl ? ctl.signal : undefined,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed (' + response.status + ')');
      return response.json();
    }).finally(function () { if (timer) clearTimeout(timer); });
  }
  function matches(id) { return desired[id] === (linesFor(id).length > 0); }
  function schedule() {
    if (flushing || flushTimer) return;
    flushTimer = setTimeout(function () { flushTimer = null; flush(); }, BATCH_MS);
  }
  function anyLine(id) {
    return ((cart && cart.items) || []).some(function (line) { return String(line.variant_id) === id; });
  }
  // One pass over every open wish, on a cart read fresh from the store. Each round is one write: /cart/update.js takes
  // the removals (line keys) and the adds of variants with no line at all in the cart (variant id: a new plain line).
  // Only an add whose variant already has a line (a gift or another marked line) goes through /cart/add.js, so a
  // protected line that happens to use the same variant is never changed. The drawer is rendered once, by the round's
  // last write; then the cart is checked for each card of the round.
  function flush() {
    if (flushing) return;
    flushing = true;
    var api = window.GBCart, failed = [];
    function fail(id) { delete desired[id]; if (failed.indexOf(id) === -1) failed.push(id); }
    api.queueMutation(async function () {
      // A tap must not act on a cached snapshot: another cart control or tab may have changed the server since.
      cart = await api.readCart(true);
      var verified = true;
      for (var round = 0; round < 12 && Object.keys(desired).length; round++) {
        var batch = {}, adds = [], updates = {};
        Object.keys(desired).forEach(function (id) {
          var existing = linesFor(id);
          if (desired[id] === (existing.length > 0)) return;
          batch[id] = versions[id];
          if (!desired[id]) existing.forEach(function (line) { updates[line.key] = 0; });
          else if (!anyLine(id)) updates[id] = 1;
          else adds.push({ id: Number(id), quantity: 1 });
        });
        var ids = Object.keys(batch);
        if (!ids.length) {
          if (!verified) { cart = await api.readCart(true); verified = true; continue; }
          Object.keys(desired).forEach(function (id) { if (matches(id)) delete desired[id]; });
          break;
        }
        ids.forEach(function (id) { running[id] = true; });
        paint();
        try {
          var fresh = null;
          if (Object.keys(updates).length) fresh = await writeCart('/cart/update.js?kaching_bundles=true', { updates: updates }, !adds.length);
          if (adds.length) fresh = await writeCart('/cart/add.js?kaching_bundles=true', { items: adds }, true);
          var rendered = fresh.sections && api.applyDrawer(fresh.sections);
          cart = Array.isArray(fresh.items) && typeof fresh.total_price === 'number' ? fresh : await api.readCart(!rendered);
          if (ids.some(function (id) { return versions[id] === batch[id] && !matches(id); })) cart = await api.readCart(true);
          api.commitCart(cart, true);
          verified = true;
          // A write the store took without the line landing must not loop: that card shows the error.
          ids.forEach(function (id) { if (versions[id] === batch[id] && !matches(id)) fail(id); });
        } catch (error) {
          console.warn('[GBGear]', error.message);
          var readConfirmed = false;
          try { cart = await api.readCart(true); readConfirmed = true; } catch (readError) {}
          verified = readConfirmed;
          // Tapped again meanwhile: the next round tries the new wish. Landed after all: nothing to show.
          ids.forEach(function (id) { if (versions[id] === batch[id] && !(readConfirmed && matches(id))) fail(id); });
          if (!readConfirmed) break;
        } finally {
          ids.forEach(function (id) { running[id] = false; });
        }
      }
    }).catch(function (error) {
      Object.keys(desired).forEach(function (id) { if (!(cart && matches(id))) fail(id); else delete desired[id]; });
      console.warn('[GBGear]', error && error.message);
    }).finally(function () {
      flushing = false;
      failed.forEach(function (id) { showError(id, 'Could not update this option. Please tap again.'); });
      paint();
      if (Object.keys(desired).length) schedule();
    });
  }
  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('[data-gbgear] [data-gbit]');
    if (!card) return;
    if (!window.GBCart || !window.GBCart.queueMutation) return;
    var id = String(card.dataset.id);
    versions[id] = (versions[id] || 0) + 1;
    desired[id] = !card.classList.contains('on');
    showError(id, ''); paint(); schedule();
  });
  document.addEventListener('keydown', function (event) {
    if (event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
    var card = event.target.closest && event.target.closest('[data-gbgear] [data-gbit]');
    if (!card) return;
    event.preventDefault(); card.click();
  });
  function boot() {
    if (booted || !window.GBCart || !window.GBCart.readCart) return;
    booted = true;
    var style = document.createElement('style');
    // Every swipe ends on a whole card at the left edge (no half-cut cards; 2026-11-01). Snapping starts with the
    // shopper's first touch on the row: switched on at load, it would follow the old first card when assets/gb-gear-packs.js
    // puts the pack cards in front of it and scroll the packs out of sight. The stacked Raven education cards (.gbul) do
    // not scroll sideways.
    style.textContent = '.gbgear [data-gbrow]{scroll-snap-type:none!important;-webkit-overflow-scrolling:touch}.gbgear:not(:has(.gbul)) [data-gbrow].gb-snap{scroll-snap-type:x mandatory!important}.gbgear:not(:has(.gbul)) [data-gbrow] .git{scroll-snap-align:start!important}.gbgear [data-gbrow].is-dragging .git:active{transform:none!important}.gbgear .git[aria-busy="true"]{cursor:progress}.gbgear .git[aria-busy="true"] .gk{color:#0354d1;background:#fff;border-color:#0354d1}';
    document.head.appendChild(style);
    window.GBCart.subscribe(function (fresh) { cart = fresh; paint(); });
    window.GBCart.readCart().then(function (fresh) { cart = fresh; paint(); }).catch(function () {});
    document.querySelectorAll('[data-gbgear]').forEach(function (widget) {
      var row = widget.querySelector('[data-gbrow]'), dots = widget.querySelector('[data-gdots]');
      if (!row || !dots) return;
      function renderDots() {
        var count = Math.max(1, Math.ceil(row.scrollWidth / Math.max(1, row.clientWidth)));
        dots.hidden = count < 2;
        if (dots.hidden) return;
        if (dots.children.length !== count) {
          dots.replaceChildren();
          for (var i = 0; i < count; i++) dots.appendChild(document.createElement('i'));
        }
        var max = row.scrollWidth - row.clientWidth;
        var selected = max > 0 ? Math.min(count - 1, Math.round(row.scrollLeft / max * (count - 1))) : 0;
        Array.from(dots.children).forEach(function (dot, index) { dot.classList.toggle('on', index === selected); });
      }
      function startSnap() { row.classList.add('gb-snap'); }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
        row.addEventListener(type, startSnap, { passive: true, once: true });
      });
      row.addEventListener('scroll', function () {
        if (!heldStill(row)) stateForRow(row).lastScrollAt = performance.now();
        if (row.scrollLeft > 8) widget.classList.add('scrolled');
        renderDots();
      }, { passive: true });
      window.addEventListener('resize', renderDots, { passive: true });
      renderDots();
    });
  }
  document.addEventListener('gb:cart-ready', boot, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})(window, document);
